import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) { }

  canActivate(): boolean {
    if (!this.auth.userIsLoggedIn()) {
      //this.router.navigate(["auth/login/simple"]);
      // TODO: fix getting redirected while connected
      console.warn('Not logged, redirecting...');
      this.router.navigate(['/user/signin']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth.guard.ts